import { Injectable } from '@angular/core';
import * as URLSearchParams from 'url-search-params';
import { Router } from '@angular/router';
import { WindowRef } from './windowRef.service';

import { UserSession } from '@mem-shared/user-session';
import { NativeIntegrationService } from './native-integration.service';
import { UtilService } from './util.service';

/**
 * Doc Viewer Service
 * This service is inteded to faciliate opening documents
 * in a new window. Often times the URL is not enough to
 * open a document (such as a PDF) and query parameters
 * must also be attached. This service will handle all
 * of this including determining if the document was
 * successfully opened and returning a success or fail
 * to the component that requested.
 //  */
@Injectable()
export class DocViewerService {
  constructor(
    private router: Router,
    private userSession: UserSession,
    private utilService: UtilService,
    private nativeService: NativeIntegrationService,
    private windowRef: WindowRef
  ) {}

  /**
   * Open Document
   * Opens a document in a new window.
   * @param url the url of the document
   * @param params params needed to fetch the correct document
   * @Param nativeName to pass the dynamic method name to native Service
   */
  openDocument(url, params, nativeName?) {
    const nativeOS = this.utilService.getNativeOS();
    if (nativeOS !== 'web') {
      this.nativeService.openPDFInNativeApp(nativeOS, url, this.mapToParams(params), nativeName);
    } else {
      //console.log(url + '?' + this.mapToParams(params));
      const docWindow = this.windowRef.nativeWindow.open(url + '?' + this.mapToParams(params));
      docWindow.onload = () => {
        if (docWindow.document['contentType'] === 'application/json') {
          if (this.router.url.includes('claims/listing/claims') || this.router.url.includes('/claims')) {
            this.userSession.setSession('customDownLoadFail', true);
            docWindow.close();
          }
          if(this.router.url.includes('claims/listing/eob')) {
            this.userSession.setSession('eobPdfDownLoadFail', true);
            docWindow.close();
          }
        }
      };
    }
  }

  /**
   * Map To Params
   * Maps a JS object to query params string; Also,
   * adds accountId and timestamp.
   * @param paramsObj Object containing the params
   */
  mapToParams(paramsObj) {
    const params = new URLSearchParams();

    // append accountid and timeStamp
    paramsObj = {
      ...paramsObj,
      accountId: this.userSession.getCurrentAccountId() || '',
      timeStamp: new Date().toISOString()
    };

    for (const key in paramsObj) {
      if (paramsObj.hasOwnProperty(key)) {
        params.set(key, paramsObj[key]);
      }
    }
    return params.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/doc-viewer.service.ts